
import {FILTERS_MAGIC_BOX_ACTIONS, FiltersMagicBoxStateInterface} from '../actions/filters-magic-box.actions';

const initialState: FiltersMagicBoxStateInterface = {
  id: null,
  Sport: null,
  Competition: null,
  Event: null,
  Leg: null,
  Category: null,
  InfoSupp: null,
  Broadcasting: null,
  for: 1,
  applyTo: null,
  refresh: true,
  showDeleted: false,
  isNonSportiveClassif: false
};

export function filtersMagicBoxReducer(state: FiltersMagicBoxStateInterface = initialState, action) {
  switch (action.type) {

    case FILTERS_MAGIC_BOX_ACTIONS.SET_FILTERS_MAGIC_BOX:
      return Object.assign({}, action.payload);

    case FILTERS_MAGIC_BOX_ACTIONS.SET_APPLY_TO_MAGIC_BOX_FILTERS:
      state.applyTo = action.payload;
      state.refresh = false;
      return Object.assign({}, state);

    case FILTERS_MAGIC_BOX_ACTIONS.REFRESH_MAGIC_BOX_FILTERS:
      state.refresh = true;
      return Object.assign({}, state);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/filters-magic-box.reducer.ts